import { render, staticRenderFns } from "./AffiliatePaymentMethods.vue?vue&type=template&id=1b2e68e2&"
import script from "./AffiliatePaymentMethods.vue?vue&type=script&lang=js&"
export * from "./AffiliatePaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePaymentMethods.vue?vue&type=style&index=0&id=1b2e68e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports